<template>
  <v-pagination
    v-model="page"
    :length="pageTotal"
    prev-icon="mdi-chevron-left"
    next-icon="mdi-chevron-right"
    :total-visible="5"
  >
  </v-pagination>
</template>

<script>
export default {
  name: 'FooterTabel',
  props: {
    pageTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  methods: {
    changePage() {
      this.$emit('changePage', this.page);
    },
  },
  watch: {
    page: 'changePage',
  },
};
</script>

<style scoped></style>
